import { useEffect, useState } from 'react';

const useDocumentFilters = (options) => {
  const { defaultQuery } = options;

  const [selectedFilter, setSelectedFilter] = useState('document_number');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [dateRange, setDateRange] = useState({ document_date: { type: 'date', start: null, end: null } });
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [includeResubmitted, setIncludeResubmitted] = useState(false);

  useEffect(() => {
    let query = buildQuery();
    setCurrentQuery(query);
  }, [selectedFilter, selectedStatus, dateRange, includeResubmitted, pagination]);

  const buildQuery = () => {
    const defaultStatus = defaultQuery.status;
    if (includeResubmitted) {
      defaultStatus.add('obsolete');
    } else {
      defaultStatus.delete('obsolete');
    }
    const docStatus = Array.from(defaultStatus);
    const query = { ...defaultQuery, ...pagination, status: docStatus };
    if (selectedStatus) {
      query['irbm_response.status'] = selectedStatus;
    }
    if (searchTerm) {
      query[selectedFilter] = searchTerm;
    }
    if (dateRange?.document_date?.start || dateRange?.document_date?.end) {
      const { start, end } = dateRange.document_date;
      const cleanDateObject = { ...(start && { start }), ...(end && { end }) };
      if (Object.keys(cleanDateObject).length) {
        query.document_date = JSON.stringify(cleanDateObject);
      }
    }

    return query;
  };
  const [currentQuery, setCurrentQuery] = useState(buildQuery());

  const handleFilterChange = (event) => setSelectedFilter(event.target.value);

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handleStatusChange = (status) => setSelectedStatus(status);

  const handleDateRangeChange = (newDateRange) => setDateRange(newDateRange);

  const handleIncludeResubmittedChange = (includeResubmittedValue) => setIncludeResubmitted(includeResubmittedValue);

  const handlePaginationChange = (page, limit) => setPagination({ page: page, limit: limit });

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      setCurrentQuery(buildQuery());
    }
  };

  return {
    selectedFilter,
    searchTerm,
    currentQuery,
    selectedStatus,
    dateRange,
    includeResubmitted,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleStatusChange,
    handleDateRangeChange,
    handleIncludeResubmittedChange,
    handlePaginationChange,
  };
};

export default useDocumentFilters;
